import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import FeaturesSection from './components/FeaturesSection';
import PageSEO from '@/components/base/PageSEO';
import { organizationSchema, websiteSchema, getWebPageSchema, getBreadcrumbSchema, getFAQSchema } from '@/mocks/seo';

const faqs = [
  { question: '春色影视需要注册才能观看吗？', answer: '不需要。春色影视完全免费，无需注册登录，打开网站即可直接观看所有影视内容。' },
  { question: '春色影视的播放画质如何？', answer: '春色影视提供全高清画质播放，支持多种清晰度切换，确保您获得最佳的观影体验。' },
  { question: '春色影视的影视资源更新频率如何？', answer: '春色影视每天实时更新最新电影、电视剧，确保您能够第一时间观看最新内容。' },
  { question: '春色影视支持哪些设备观看？', answer: '春色影视支持电脑、平板、手机全平台观看，随时随地畅享影视内容。' },
  { question: '播放会卡顿吗？', answer: '春色影视采用自主研发的极速播放引擎和智能CDN加速技术，确保秒开不缓冲，流畅播放。' },
];

export default function Home() {
  return (
    <>
      <PageSEO
        schemas={[
          organizationSchema,
          websiteSchema,
          getWebPageSchema(
            '春色影视 | 不缓冲流畅播放 高清免费在线观看 免费不收费',
            '春色影视确保不缓冲流畅播放，高清免费在线观看，免费不收费，秒开无卡顿极速影视体验，电影电视剧全集实时更新。',
            'https://chunseys.com/',
          ),
          getBreadcrumbSchema([{ name: '首页', url: 'https://chunseys.com/' }]),
          getFAQSchema(faqs),
        ]}
      />
      <main>
        <HeroSection />
        <FeaturedSection />
        <CategorySection />
        <LatestSection />
        <FeaturesSection />
      </main>
    </>
  );
}